import { React, useState, useEffect } from 'react';
import { Alert, PayoutService } from '../../services';
import moment from 'moment';
import Pagination from '../../components/Pagination';
import { useNavigate, useParams } from 'react-router-dom';
import { ConfigService } from '../../services';
import 'react-loading-skeleton/dist/skeleton.css';
import ButtonLoader from '../../components/ButtonLoader';
import {
  CrossIcon,
  DatepickerSvgIcon,
  DownArrowIcon,
  DownloadIcon,
  LeftArrowIcon,
  UpArrowIcon,
} from '../../components/icons/IconProvider';
import { formatValue } from '../../utils/Helper';
import TableComponent from '../../components/TableComponent';
const PayoutUserList = () => {
  const [showPayoutModal, setPayoutModal] = useState(false);
  let params = useParams();
  let projectId = params ? params.project_id : null;
  let payoutId = params ? params.payout_id : null;
  const [userPayoutList, setUserPayoutList] = useState([]);
  const [isPayoutDetails, setPayoutDetails] = useState(null);
  const [isDownloadLoader, setDownloadLoader] = useState(false);
  const [isLoader, setLoader] = useState(false);
  const [isPagination, setPagination] = useState({
    totalPages: 10,
    currentPage: 1,
    totalCount: 0,
  });
  const [isDividend, setDividend] = useState({
    status: false,
    index: null,
  });

  const navigate = useNavigate();
  const [filterPayoutData, setFilterPayoutData] = useState({
    perPage: 10,
    page: 1,
    commonSearch: '',
    project_id: projectId,
    user_id: '',
    payout_id: payoutId,
  });

  const getUserPayoutList = async () => {
    try {
      //call fiat transaction api
      setLoader(true);
      let userPayoutResponse = await PayoutService.getUserPayoutList(
        filterPayoutData.perPage,
        filterPayoutData.page,
        filterPayoutData.commonSearch,
        filterPayoutData.project_id,
        filterPayoutData.user_id,
        filterPayoutData.payout_id,
      );
      if (userPayoutResponse.status === 'failure') {
        setLoader(false);
        Alert.error(userPayoutResponse.message);
        return false;
      }
      setUserPayoutList([...userPayoutResponse.data.records]);
      setPayoutDetails(userPayoutResponse.data.payoutDetails);
      setPagination({
        totalPages: userPayoutResponse.data.pagination.totalPages,
        currentPage: userPayoutResponse.data.pagination.page,
        totalCount: userPayoutResponse.data.pagination.totalCount,
      });
      setLoader(false);
    } catch (error) {
      setLoader(false);
      Alert.error(error.message);
      return false;
    }
  };
  useEffect(() => {
    (async () => {
      await getUserPayoutList();
    })();
  }, [filterPayoutData]);
  const handlePagination = (current) => {
    setPagination({ ...isPagination, currentPage: current });

    setFilterPayoutData({
      ...filterPayoutData,
      page: current,
    });
  };
  const downloadPayoutXml = async () => {
    setDownloadLoader(true);
    try {
      const generateDividend = {
        payout_id: payoutId,
      };
      let response = await PayoutService.generatePayoutXML(generateDividend);

      if (response.status === 'failure') {
        setDownloadLoader(false);
        Alert.error(response.message);
        return false;
      }
      let fileName =
        isPayoutDetails.symbol_name +
        '-Payout-' +
        moment(isPayoutDetails?.from_date).format('DD-MM-YY') +
        '-' +
        moment(isPayoutDetails?.to_date).format('DD-MM-YY') +
        '.xml';
      const fileContent = response;

      const fileBlob = new Blob([fileContent], {
        type: 'application/octet-stream',
      });
      const fileURL = URL.createObjectURL(fileBlob);

      const anchor = document.createElement('a');
      anchor.href = fileURL;
      anchor.download = fileName; // Replace 'filename.extension' with the desired file name and extension.
      anchor.style.display = 'none';

      document.body.appendChild(anchor);
      anchor.click();

      // Clean up
      URL.revokeObjectURL(fileURL);
      document.body.removeChild(anchor);
      setDownloadLoader(false);
    } catch (error) {
      setDownloadLoader(false);
      Alert.error(error.message);
      return false;
    }
  };

  return (
    <div className="">
      <div className="md:flex items-center mb-4 justify-between">
        <div className="flex md:items-center md:mb-0 mb-4">
          <div
            onClick={() => navigate(-1)}
            className="w-11 h-11 rounded-full flex items-center justify-center bg-gray-50 mr-3 cursor-pointer"
          >
            <LeftArrowIcon />
          </div>
          <h4 className="">{isPayoutDetails?.project_name || 'NA'}</h4>
        </div>
        <button
          onClick={() => downloadPayoutXml()}
          disabled={isPayoutDetails?.dividend_status === 1 ? true : false}
          className={`px-4 py-2 font-medium inline-flex items-center justify-center bg-BlueText text-white text-base hover:bg-[#2D439A]
            ${isPayoutDetails?.dividend_status === 0 ? 'hover:bg-[#2D439A]' : ' bg-[#787a7d] cursor-not-allowed'}`}
        >
          {isDownloadLoader ? (
            <ButtonLoader title={'Downloading'} />
          ) : (
            <div className="flex items-center gap-2">
              <DownloadIcon />
              Download XML
            </div>
          )}
        </button>
      </div>

      <div className="w-full bg-brandGray px-5 py-4 rounded-xl mb-4">
        <div className="grid grid-cols-3 gap-4">
          <div className="">
            <p className="">Duration:</p>
            <p className="font-semibold">
              {isPayoutDetails
                ? ConfigService.formatDate(isPayoutDetails?.from_date, 'dmy')
                : ''}{' '}
              -{' '}
              {isPayoutDetails
                ? ConfigService.formatDate(isPayoutDetails?.to_date, 'dmy')
                : ''}
            </p>
          </div>
          <div className="">
            <p className="">Investors:</p>
            <p className="font-semibold">{isPagination?.totalCount || '0'}</p>
          </div>
          <div className="">
            <p className="">Payout Due:</p>
            <p className="font-semibold">
              {isPayoutDetails?.dividend_status === 0
                ? formatValue(isPayoutDetails?.dividend, { decimalPlaces: 2 })
                : '0'}
            </p>
          </div>
        </div>
      </div>

      <UserList
        userPayoutList={userPayoutList}
        isLoader={isLoader}
        setDividend={setDividend}
        isDividend={isDividend}
        isPagination={isPagination}
        handlePagination={handlePagination}
      />

      {showPayoutModal ? (
        <div>
          <div className="justify-center flex items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-full mx-3 my-4 max-w-md">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="flex justify-between items-center py-3 px-6">
                  <h3>Generate Payout</h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black text-3xl leading-none font-semibold outline-none focus:outline-none absolute right-1 top-3 z-10 flex justify-center items-center"
                    onClick={() => setPayoutModal(false)}
                  >
                    <CrossIcon />
                  </button>
                </div>
                <div className="py-3 px-6">
                  <div className="mb-4">
                    <p className="text-sm md:text-md mb-2">Amount</p>
                    <input placeholder="Profit Amount" />
                  </div>
                  <div className="mb-4">
                    <p className="text-sm md:text-md mb-2">From</p>
                    <div className="relative">
                      <input placeholder="Select To Date" />
                      <DatepickerSvgIcon />
                    </div>
                  </div>
                  <div className="mb-4">
                    <p className="text-sm md:text-md mb-2">To</p>
                    <div className="relative">
                      <input placeholder="Select To Date" />
                      <DatepickerSvgIcon />
                    </div>
                  </div>
                </div>
                {/*footer*/}
                <div className="pb-6 px-6 text-center">
                  <button
                    className="bg-GreenColor active:bg-[#92C24B] text-brandBlue border border-GreenColor font-bold uppercase text-sm px-6 py-3 rounded-lg w-auto inline-block shadow hover:shadow-lg outline-none focus:outline-none  mb-1 ease-linear transition-all duration-150"
                    type="button"
                  >
                    Generate
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </div>
      ) : null}
    </div>
  );
};
export default PayoutUserList;

const UserList = ({
  userPayoutList,
  isLoader,
  setDividend,
  isDividend,
  isPagination,
  handlePagination,
}) => {
  const tableConfig = {
    columns: {
      full_name: {
        title: 'User Name',
        render: (data) => {
          return data.userData ? data.userData.full_name : '';
        },
      },
      email: {
        title: 'Email',
        render: (data) => {
          return data.userData ? data.userData.email : '';
        },
      },
      tokens: {
        title: 'Tokens',
        render: (data) => {
          return data?.NFT_total_quantity || '0';
        },
      },
      payout_due: {
        title: 'Payout Due',
        render: (data) => {
          return data?.projectPayout?.status === 0
            ? formatValue(data?.payout_amount, {
                decimalPlaces: 2,
              })
            : '0';
        },
      },
      total_payout_due: {
        title: 'Total Payout Paid',
        render: (data) => {
          return (
            formatValue(data?.total_paid_payout_amount, {
              decimalPlaces: 2,
            }) || '0'
          );
        },
      },
      action: {
        title: '',
        render: (data, index) => (
          <div
            className="cursor-pointer flex items-center"
            onClick={() => {
              setDividend((prevState) => ({
                status: prevState.index === index ? !prevState.status : true,
                index,
              }));
            }}
          >
            History{' '}
            {isDividend.index === index && isDividend.status ? (
              <UpArrowIcon />
            ) : (
              <DownArrowIcon />
            )}
          </div>
        ),
      },
    },
    data: userPayoutList,
  };

  return (
    <>
      <div className="w-full bg-brandGray px-5 py-4 rounded-xl">
        <div className="grid grid-cols-1 items-center">
          <div className="flex justify-end items-center"></div>
        </div>
        <div className="flex flex-col relative overflow-x-auto w-full">
          <TableComponent
            tableConfig={tableConfig}
            isListLoader={isLoader}
            isList={userPayoutList}
            isDividend={isDividend}
            setDividend={setDividend}
            expandedRowRender={(data, index) => {
              if (
                isDividend.index === index &&
                data?.user_payout_history?.length > 0
              ) {
                return (
                  <div className="bg-white px-6 py-4">
                    <h4 className="text-lg font-semibold mb-2">
                      Payout History
                    </h4>
                    <table className="tableradus table-auto w-full text-sm text-left border-separate border-spacing-y-3 shadow-none">
                      <thead className="text-xs uppercase sr-only">
                        <tr className="bg-white">
                          <th className="px-6 py-4 td-class" colSpan={1}>
                            #
                          </th>
                          <th className="px-6 py-4 td-class" colSpan={2}>
                            Duration
                          </th>
                          <th className="px-6 py-4 td-class" colSpan={4}>
                            Payout
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {data &&
                          data?.user_payout_history &&
                          data?.user_payout_history.length > 0 &&
                          data?.user_payout_history.map((element, index) => {
                            return (
                              <tr key={index}>
                                <td className="px-6 py-4 td-class" colSpan={1}>
                                  {element.id}
                                </td>
                                <td className="px-6 py-4 td-class" colSpan={2}>
                                  {ConfigService.dateFormat(
                                    element?.projectPayout?.from_period,
                                    false,
                                  )}{' '}
                                  -{' '}
                                  {ConfigService.dateFormat(
                                    element?.projectPayout?.to_period,
                                    false,
                                  )}
                                </td>
                                <td className="px-6 py-4 td-class" colSpan={4}>
                                  {formatValue(element?.payout_amount, {
                                    decimalPlaces: 2,
                                  }) || '0'}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                );
              }
              return null;
            }}
          />
        </div>
        {userPayoutList && userPayoutList.length > 0 && isLoader === false && (
          <Pagination
            total={isPagination.totalPages}
            current={isPagination.currentPage}
            pagination={(crPage) => handlePagination(crPage)}
          />
        )}
      </div>
    </>
  );
};
